import React, { useState } from 'react';
import { Linkedin, Twitter, Mail, MapPin, Send, Quote } from 'lucide-react';
import './Contact.css'; 
import Squares from '../Squares/Squares';

const Contact = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const contactInfo = [
    {
      id: 'email',
      icon: Mail,
      label: 'Email',
      value: 'zmaholobela12@gmail.com',
      href: 'mailto:zannymaholobela01@gmail.com',
      color: '#009970',
      external: false // Email doesn't need new tab
    },
    {
      id: 'linkedin',
      icon: Linkedin,
      label: 'LinkedIn',
      value: 'Connect with me',
      href: 'https://www.linkedin.com/in/zannymaholobela/',
      color: '#0077b5',
      external: true // Open in new tab
    },
    {
      id: 'twitter',
      icon: Twitter,
      label: 'Twitter',
      value: 'Follow me',
      href: 'https://x.com/Athalia__m',
      color: '#1da1f2',
      external: true // Open in new tab
    },
    {
      id: 'location',
      icon: MapPin,
      label: 'Location',
      value: 'Johannesburg, Gauteng',
      href: '#',
      color: '#009970',
      external: false // Location doesn't need new tab
    }
  ];

  return (
    <div className="contact-container" style={{ position: 'relative', overflow: 'hidden', background: '#1a1a1a',paddingTop: '20px' }}>
      {/* Animated background */}
      <div className="background-animation">
        <Squares
          speed={0.5}
          squareSize={40}
          direction='diagonal'
          borderColor='rgba(0, 153, 112, 0.15)'
          hoverFillColor='rgba(0, 153, 112, 0.1)'
        />
      </div>
     
      <div className="contact-content">
        <div className="contact-header">
          <h1 className="contact-title">Stay in touch</h1>
          <div className="title-underline"></div>
          <p className="contact-subtitle">
            Let's connect and create something amazing together
          </p>
        </div>

        {/* Quote Section */}
        <div className="quote-section">
          <div className="quote-card">
            <Quote className="quote-icon" size={32} />
            <blockquote className="quote-text">
              "Live as if you were to die tomorrow. Learn as if you were to live forever."
            </blockquote>
            <div className="quote-author">- Mahatma Gandhi</div>
          </div>
        </div>

        <div className="contact-grid">
          {contactInfo.map((item) => {
            const IconComponent = item.icon;
            return (
              <div
                key={item.id}
                className={`contact-card ${hoveredCard === item.id ? 'hovered' : ''}`}
                onMouseEnter={() => setHoveredCard(item.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <a 
                  href={item.href} 
                  className="contact-link"
                  target={item.external ? "_blank" : "_self"}
                  rel={item.external ? "noopener noreferrer" : undefined}
                >
                  <div className="card-icon-wrapper">
                    <IconComponent 
                      className="card-icon" 
                      size={28}
                      style={{ color: item.color }}
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-label">{item.label}</h3>
                    <p className="card-value">{item.value}</p>
                  </div>
                  <div className="card-arrow">
                    <Send size={16} />
                  </div>
                </a>
              </div>
            );
          })}
        </div>

        <div className="contact-footer">
          <div className="pulse-circle">
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
            <div className="pulse-ring"></div>
          </div>
          <p className="footer-text">Want to collaborate?</p>
          <p className="footer-subtext">Let's turn our ideas into reality</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;